module.exports = __webpack_public_path__ + "img/promo.75c1e4e.png";